import { ensureConstructorIdentity } from "src/lib/constructor";
import { ConstructorTrackingDataInput } from "src/types/graphql.d";
import { getStorageItem } from "src/utils/helper/localStorage";
import {
  CONSTRUCTOR_CLIENT_ID_STORAGE_KEY,
  CONSTRUCTOR_SESSION_ID_STORAGE_KEY,
} from "./constants";

/**
 * Constructor.io's client_id/session_id identity, sent as the constructor_tracking_data GraphQL
 * variable on carousel queries so cp-recommendations can forward it to Constructor as the
 * `i`/`s` params. The identity is created first when the beacon (see _app.tsx) hasn't created
 * it yet, so the first carousel request of a visit carries it too. It's then read from the
 * localStorage keys the beacon shares, which the beacon keeps current as the session moves on.
 */
export const getConstructorTrackingData = (): ConstructorTrackingDataInput => {
  ensureConstructorIdentity();

  return {
    client_id: getStorageItem<string>(CONSTRUCTOR_CLIENT_ID_STORAGE_KEY),
    client_session: getStorageItem<string>(CONSTRUCTOR_SESSION_ID_STORAGE_KEY),
  };
};
